/**
 * Maps deployment hostnames to their tenant keys.
 * Add new entries here when onboarding a new tenant.
 */
export const HOSTNAME_TO_TENANT = {
  'sandbox-tfs-admin-portal.poshvine.com': 'tfs',
  'tfs-admin-dashboard.poshvine.com': 'tfs',
  'sandbox-collinson-admin-portal.poshvine.com': 'collinson',
  'collinson-admin-portal.poshvine.com': 'collinson',
} as const;
